<template>
  <b-modal id="DigitalSignatureSendModal"
           @hidden="resetModal" no-close-on-backdrop>
    <template #modal-header>
      <h5>{{ $t('SendDigitalConsentForm') }}</h5>
      <font-awesome-icon class="close" icon="fa-regular fa-xmark" @click="$bvModal.hide('DigitalSignatureSendModal')" />
    </template>

    <b-alert show variant="info" class="mb-4">
      <i class="fa fa-info-circle mr-2"></i>
      {{ $t('DigitalConsentFormDescription') }}
    </b-alert>

    <div class="form-group mb-3">
      <label class="font-weight-bold">{{ $t('Customer') }}</label>
      <p class="form-control-plaintext">{{ customerName }}</p>
    </div>

    <div class="form-group mb-3">
      <label class="font-weight-bold">{{ $t('Phone') }}</label>
      <p class="form-control-plaintext">{{ customerPhone || '-' }}</p>
      <small v-if="!customerPhone" class="text-danger">{{ $t('CustomerPhoneRequired') }}</small>
    </div>

    <div class="form-group mb-3">
      <label class="font-weight-bold">{{ $t('Form') }}</label>
      <p class="form-control-plaintext">{{ formName }}</p>
    </div>

    <template #modal-footer>
      <b-button variant="secondary" @click="$bvModal.hide('DigitalSignatureSendModal')" :disabled="isSending">
        {{ $t('Cancel') }}
      </b-button>
      <b-button variant="primary" @click="sendDigitalSignature" :disabled="isSending || !customerPhone">
        <span v-if="isSending">
          <i class="fa fa-spinner fa-spin mr-1"></i>{{ $t('Sending') }}
        </span>
        <span v-else>
          <i class="fa fa-paper-plane mr-1"></i>{{ $t('Send') }}
        </span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import axios from '../../services/index'

  export default {
    name: 'DigitalSignatureSendModal',
    data() {
      return {
        customerId: null,
        customerName: '',
        customerPhone: '',
        formName: '',
        customConsentFormId: null,
        customerConsentFormId: null,
        branchId: null,
        isSending: false
      }
    },
    methods: {
      open(params) {
        this.customerId = params.customerId;
        this.customerName = params.customerName;
        this.customerPhone = params.customerPhone;
        this.formName = params.formName;
        this.customConsentFormId = params.customConsentFormId;
        this.customerConsentFormId = params.customerConsentFormId;
        this.branchId = params.branchId;
        this.$bvModal.show('DigitalSignatureSendModal');
      },
      async sendDigitalSignature() {
        this.isSending = true;

        try {
          const response = await axios.post('/api/digitalSignature/send', {
            customerID: this.customerId,
            customConsentFormID: this.customConsentFormId,
            branchID: this.branchId,
            customer_ConsentFormID: this.customerConsentFormId
          });

          if (response.data && response.data.isSucceeded) {
            this.$toastr.success(this.$t('DigitalConsentFormSentSuccessfully'));
            this.$emit('sent');
            this.$bvModal.hide('DigitalSignatureSendModal');
          } else {
            var errorKey = response.data?.errorMessage || 'Error';
            this.$toastr.error(this.$t(errorKey));
          }
        } catch {
          this.$toastr.error(this.$t('Error'));
        } finally {
          this.isSending = false;
        }
      },
      resetModal() {
        this.customerId = null;
        this.customerName = '';
        this.customerPhone = '';
        this.formName = '';
        this.customConsentFormId = null;
        this.customerConsentFormId = null;
        this.branchId = null;
        this.isSending = false;
      }
    }
  }
</script>
